import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f83ba2d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "exam_left_info" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "table" }
const _hoisted_4 = { class: "qu" }
const _hoisted_5 = ["onClick"]

import { ref } from 'vue'
    import store from "@/store"
    
export default /*#__PURE__*/_defineComponent({
  __name: 'quList',
  props: ['data', 'index', 'progress'],
  emits: ['choose'],
  setup(__props, { emit: __emit }) {

    const props = __props
    const emit = __emit
    const exam = ref(store.state.exam)
    
    const changeIndex = (i:number) => {
        emit('choose', i)
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode("答题进度"),
      _createElementVNode("span", null, _toDisplayString(props.progress) + "/" + _toDisplayString(__props.data.length), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, i) => {
          return (_openBlock(), _createElementBlock("span", {
            onClick: ($event: any) => (changeIndex(i)),
            key: i,
            class: _normalizeClass({cur: i === __props.index, selected: item.selected, mark: item.mark })
          }, _toDisplayString(i+1), 11, _hoisted_5))
        }), 128))
      ])
    ])
  ]))
}
}

})